<div id="Notificaciones" [ngClass]="{ view: view }">
  <notification-header></notification-header>

  <div class="notificaciones_content">
    <div class="sub-header">
      <div class="last">
        <h2>Últimas</h2>
      </div>
      <div>
        <p class="makeread" (click)="marcarLeidas()">
          Marcar todas como leidas
        </p>
      </div>
    </div>
    <notification-item
      *ngFor="let notificacion of notificaciones"
      [notificacion]="notificacion"
      (click)="close()"
    ></notification-item>
  </div>
</div>
